import { Icon } from '@chakra-ui/react';

export default function CheckFatOutlineIcon(props) {
  return (
    <Icon
      data-testid='check-outline-icon'
      width='25'
      height='26'
      viewBox='0 0 25 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M23.7576 7.16383L21.4138 4.86305C21.121 4.57114 20.7243 4.40723 20.3108 4.40723C19.8973 4.40723 19.5006 4.57114 19.2078 4.86305L10.156 13.8035L6.57301 10.3269C6.27953 10.036 5.88273 9.8731 5.46946 9.87402C5.05619 9.87493 4.66012 10.0395 4.36793 10.3318L2.02418 12.6755C1.73167 12.9685 1.56738 13.3656 1.56738 13.7796C1.56738 14.1935 1.73167 14.5906 2.02418 14.8836L9.01832 21.9148C9.16342 22.0599 9.33568 22.1751 9.52527 22.2536C9.71487 22.3322 9.91808 22.3726 10.1233 22.3726C10.3285 22.3726 10.5317 22.3322 10.7213 22.2536C10.9109 22.1751 11.0832 22.0599 11.2283 21.9148L23.7625 9.3777C23.9079 9.23221 24.0231 9.05944 24.1016 8.86931C24.18 8.67919 24.2202 8.47543 24.2197 8.26975C24.2193 8.06406 24.1782 7.86049 24.0989 7.67071C24.0196 7.48093 23.9036 7.30868 23.7576 7.16383ZM10.1189 20.8123L3.12476 13.781L5.46851 11.4373C5.47136 11.4396 5.47397 11.4422 5.47633 11.4451L9.61207 15.4578C9.75806 15.6006 9.9542 15.6806 10.1585 15.6806C10.3627 15.6806 10.5588 15.6006 10.7048 15.4578L20.3181 5.96852L22.656 8.2732L10.1189 20.8123Z'
        fill='currentColor'
      />
    </Icon>
  );
}
